var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherFog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.5 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,5.9c0-1.7-1.3-3-3-3s-.4,0-.6,0c-.3-1.3-1.5-2.2-2.9-2.2s-2.6,1-2.9,2.2c-.1,0-.3,0-.4,0-1.7,0-3,1.3-3,3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 7.9,
    x2: 14,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 9.5,
    x2: 14,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 11.1,
    x2: 14,
    y2: 11.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherFog);
export default __webpack_public_path__ + "static/media/icon_weather_fog.ea1dbbc9902c6a29aacfa25fda297ac7.svg";
export { ForwardRef as ReactComponent };